module.exports = __webpack_public_path__ + "img/news.1bf76671.svg";